import { LOCALE } from './locales';

export interface IMomentSettings {
    date: string;
    time: string;
    month?: string;
    isMonthDeclensionNeeded?: boolean;
}

export const DEFAULT_MOMENT_MONTH_FORMAT = 'MMMM';
export const DEFAULT_MONTH_DECLENSION = true;

export const LANGUAGES_MOMENT_FORMAT: {[key: string]: IMomentSettings} = {
    [LOCALE.AR_AE]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.CS_CZ]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.DA_DK]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.DE_DE]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.EN_AU]: {
        date: 'Do',
        time: 'hh:mm a'
    },
    [LOCALE.EN_CA]: {
        date: 'Do',
        time: 'hh:mm a'
    },
    [LOCALE.EN_GB]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.EN_US]: {
        date: 'Do',
        time: 'hh:mm a'
    },
    [LOCALE.ES_ES]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.ES_MX]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.FI_FI]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.FR_CA]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.FR_FR]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.HU_HU]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.IT_IT]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.JA_JP]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.KO_KR]: {
        date: 'Do',
        time: 'hh:mm a'
    },
    [LOCALE.NB_NO]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.NL_NL]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.NN_NO]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.PL_PL]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.PT_BR]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.PT_PT]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.RU_RU]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.SV_SE]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.TH_TH]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.TR_TR]: {
        date: 'Do',
        time: 'HH:mm'
    },
    [LOCALE.UK_UA]: {
        date: 'D',
        time: 'HH:mm'
    },
    [LOCALE.ZH_CN]: {
        date: 'Do',
        time: 'HH:mm',
        month: 'MMM'
    },
    [LOCALE.ZH_TW]: {
        date: 'Do',
        time: 'HH:mm',
        month: 'MMM'
    }
};
